import React from 'react'
import Popover from '@mui/material/Popover';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import './menu.css'


const Menu = ({ menu }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const isActive = (menu) => {
        // Regular expression to match the base URL
        var baseUrlPattern = /^https?:\/\/[a-zA-Z0-9.-]+/;
        // Replace the base URL with an empty string
        var withport = window.location.href.replace(baseUrlPattern, '');
        return menu?.to == withport.replace(new RegExp(`.*?${"/"}`), "/").replace("/#", "");
    }
    console.log("sub-menu", menu.submenus)
    if (menu.submenus && Array.isArray(menu.submenus) && menu.submenus.length != 0) {
        return <>
            <Box className="menu">
                <Box
                    className={'menu-iteme ' + (isActive(menu) ? 'bg-yellow  shadow black' : 'bg-light-gray')}
                    sx={{
                        transition: 'background-color 0.3s ease',
                        '&:hover': {
                            // Added !important to force override the css class
                            backgroundColor: isActive(menu) ? undefined : '#e0e0e0 !important'
                        }
                    }}
                    onClick={handlePopoverOpen}
                    onMouseEnter={handlePopoverOpen}
                // onMouseLeave={handlePopoverClose}
                >
                    {menu?.icon}
                </Box>
                <div className='dark-gray menu-text' dangerouslySetInnerHTML={{ __html: menu?.label }}></div>
                <Box>
                    <Popover
                        id="mouse-over-popover"
                        sx={{ p: 2, borderRadius: 10 }}
                        open={open}
                        anchorEl={anchorEl}
                        disableScrollLock
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                        slotProps={{
                            paper: {
                                sx: {
                                    p: 2,
                                    borderRadius: 3, // 3 = theme spacing
                                    m: 1
                                },
                            },
                        }}
                    >

                        {(menu?.submenus || []).map((menu) => <Link to={menu?.to} className='menu'>
                            <Box
                                className={'menu-iteme ' + (isActive(menu) ? 'bg-yellow  shadow black' : 'bg-light-gray1')}
                                sx={{
                                    transition: 'background-color 0.3s ease',
                                    '&:hover': {
                                        // Added !important to force override the css class
                                        backgroundColor: isActive(menu) ? undefined : '#e0e0e0 !important'
                                    }
                                }}
                            >
                                {menu?.icon}
                            </Box>
                            <div className='dark-gray menu-text' dangerouslySetInnerHTML={{ __html: menu?.label }}></div>
                        </Link>)}
                    </Popover>
                </Box>
            </Box>
        </>
    }

    return <Link to={menu?.to} className='menu'>
        <Box
            className={'menu-iteme ' + (isActive(menu) ? 'bg-yellow  shadow black' : 'bg-light-gray1')}
            sx={{
                transition: 'background-color 0.3s ease',
                '&:hover': {
                    // Added !important to force override the css class
                    backgroundColor: isActive(menu) ? undefined : '#e0e0e0 !important'
                }
            }}
        >
            {menu?.icon}
        </Box>
        <div className='dark-gray menu-text' dangerouslySetInnerHTML={{ __html: menu?.label }}></div>
    </Link>



}
const SideBar = ({ menus }) => {
    return (

        <div className='card-bg1 side-bar' id="side-bar">
            <div className='menu-bar'>
                {menus?.map((menu, index) => (menu && <>
                    <Menu menu={menu} />
                </>))}
            </div>
        </div>
    )
}
export default SideBar